// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__YLBMY","link":"Navigation_link__6C+-N"};